import React from 'react'

function MenuItems({menuItem}) {
    return (
        <div className="portfolis">
            {
                menuItem.map((item)=>{
                    return <div className="portfolio" key={item.id}>
                        <div className="image-data">
                            <img src={item.ogImage || item.image} alt={item.ogTitle || item.title}/>
                            <ul className="hover-items">
                                <li>
                                    <a href={item.link1} target="_blank" rel="noreferrer">{item.icon1}</a>
                                    {item.link2 && <a href={item.link2} target="_blank" rel="noreferrer">{item.icon2}</a>}
                                </li>
                            </ul>
                        </div>
                        <div className="og-meta">
                            <span className="og-label">Open Graph preview</span>
                            <span className="og-domain">{item.domain}</span>
                        </div>
                        <h5>
                            {item.ogTitle || item.title}
                        </h5>
                        <p className="portfolio-description">{item.ogDescription || item.description}</p>
                        <div className="portfolio-tech">
                            {item.tech.split(', ').map((tech) => (
                                <span key={tech}>{tech}</span>
                            ))}
                        </div>
                    </div>
                })
            }
        </div>
    )
}

export default MenuItems;
